import React from 'react'
import PropTypes from 'prop-types'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

const KeyContact = (props) => {
  const { callbacks, contact, isLast } = props
  const { createOrEditKeyContact } = callbacks

  const {
    contact_email,
    contact_name,
    contact_number,
  } = contact

  return (
    <DashboardModuleListItem
      boxProps={{ borderBottom: isLast ? '1px solid' : '1px dashed' }}
      onClick={() => createOrEditKeyContact()}
      secondaryText={contact_email}
      title={contact_name}
    >
      <DashboardModuleListItem.TertiaryText>
        {contact_number}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

KeyContact.propTypes = {
  callbacks: PropTypes.shape({
    createOrEditKeyContact: PropTypes.func.isRequired,
  }).isRequired,
  contact: PropTypes.object.isRequired,
  isLast: PropTypes.bool,
}

export default KeyContact
